module.exports = __webpack_public_path__ + "img/linyun-iocn.e3d02d88.png";